import React, { useEffect, useState } from "react";
import MultiCarousalLogo from "../../../../pages/public/home/components/components/multicarousals/multi.carousallogo";

/** Returns current window inner width, updates on resize. */
function useWindowWidth() {
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  useEffect(() => {
    const handler = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return width;
}

export default function PartnerSection(props) {
  const [isActive, setIsActive] = useState(props.isActive);
  const [dataD, setDataD] = useState([]);
  const windowWidth = useWindowWidth();

  let lang = props.state.language;

  useEffect(() => {
    if (!props.data) return;

    if (props.active === "3") {
      setDataD(props.mouList || []);
    } else if (props.active === "2") {
      setDataD(props.membershipList || []);
    } else if (props.active === "0") {
      setDataD(props.companyList || []);
    } else if (props.active === "1") {
      setDataD(props.premisesList || []);
    } else if (props.active === "4") {
      setDataD(props.institutionList || []);
    } else {
      let filteredArray = props.data.filter(
        (item) => String(item.type) === String(props.active)
      );
      setDataD(filteredArray);
    }
  }, [
    props.data,
    props.active,
    props.mouList,
    props.membershipList,
    props.companyList,
    props.premisesList,
    props.institutionList,
  ]);

  /**
   * Use infinite scroll when:
   *  - There are more than 5 items, OR
   *  - The screen is narrow enough that a static row would wrap/overflow
   *    (threshold scales with item count so 1-2 items never scroll needlessly)
   */
  const SCROLL_THRESHOLD = 4;
  // On mobile (<576px) always scroll; on tablet (<992px) scroll if items > 3
  const useScroll =
    dataD.length > SCROLL_THRESHOLD ||
    (windowWidth < 576) ||
    (windowWidth < 992 && dataD.length > 3);

  return (
    <div className="pt-4">
      {dataD?.length > 0 && (
        <div className="org-sub-containers" key={props?.active}>
          {useScroll ? (
            /* ── Infinite scroll strip ── */
            <MultiCarousalLogo key={props.active} speed={1500}>
              {dataD.map((item, index) => (
                <img
                  className="par-avatar-partners"
                  key={`${props.active}-${item.id || index}`}
                  src={item.logo || item.image}
                  alt={item.organization_name || `Partner ${index + 1}`}
                  // onError={(e) => {
                  //   e.target.onerror = null;
                  //   e.target.src = "/resources/logo/default-logo.png";
                  // }}
                />
              ))}
            </MultiCarousalLogo>
          ) : (
            /* ── Static centered row (≤5 items on a wide screen) ── */
            <div className="d-flex justify-content-evenly align-items-center w-100">
              {dataD.map((item, index) => (
                <img
                  className="par-avatar-partners"
                  key={`static-${props.active}-${item.id || index}`}
                  src={item.logo || item.image}
                  alt={item.organization_name || `Partner ${index + 1}`}
                  // onError={(e) => {
                  //   e.target.onerror = null;
                  //   e.target.src = "/resources/logo/default-logo.png";
                  // }}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
